import React from 'react';

const Ratings = () => {
    return null;
}

export default Ratings;
